import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Heading } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { Section, getSectionSpacing } from '../Section/Section.js';

var StyledSectionContent = styled(Section)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n\n    ", "\n  "])), getSectionSpacing({
    theme: theme,
    xPadding: [4, 8, 12, 24],
    yPadding: [4, 8, 12, 24],
    maxWidth: '1200px'
  }));
});
var Header = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  align-self: center;\n  margin-bottom: ", ";\n  text-align: center;\n"], ["\n  display: flex;\n  align-items: center;\n  align-self: center;\n  margin-bottom: ", ";\n  text-align: center;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[16];
});
var SectionContent = function (_a) {
  var children = _a.children,
    title = _a.title,
    name = _a.name,
    reference = _a.reference,
    background = _a.background;
  return jsxs(StyledSectionContent, {
    name: name,
    reference: reference,
    background: background,
    children: [title && jsx(Header, {
      children: jsx(Heading, {
        heading: "h2",
        children: title
      })
    }), children]
  });
};
var templateObject_1, templateObject_2, templateObject_3;

export { SectionContent, StyledSectionContent };
//# sourceMappingURL=SectionContent.js.map
